// A category's `name` is its full path ("Sports > Eyewear > Sunglasses"); every label drawn from
// one shows only the leaf. Pure functions, no React, no data access.
export const leafName = (name: string): string => name.split(">").pop()?.trim() ?? name;

export interface FitNameCountInput {
  /** Rendered width of each name, in the order shown. */
  nameWidths: number[];
  /** Width of the ", " between two names. */
  separatorWidth: number;
  /** `suffixWidths[r]` is the width of the " +r" suffix when r names are hidden (index 0 unused). */
  suffixWidths: number[];
  available: number;
}

// How many leading names fit on one line: the largest k whose names, joined, plus the " +{n - k}"
// suffix when k < n, fit the available width. Never below one: a first name that does not fit is
// truncated by the caller, with the suffix kept. Pure, so the layout decision is testable without a layout.
export const fitNameCount = ({ nameWidths, separatorWidth, suffixWidths, available }: FitNameCountInput): number => {
  const n = nameWidths.length;
  if (n <= 1) return n;
  for (let k = n; k > 1; k--) {
    const names = nameWidths.slice(0, k).reduce((sum, w) => sum + w, 0) + (k - 1) * separatorWidth;
    if (names + (k < n ? suffixWidths[n - k] : 0) <= available) return k;
  }
  return 1;
};
